export {
  ExpertBio,
  type ExpertBioProps,
  type ExpertBioHighlight,
  type ExpertBioHeadingContext,
} from './ExpertBio';
export {
  expertBioContainerVariants,
  expertBioImageVariants,
  type ExpertBioContainerVariantProps,
  type ExpertBioImageVariantProps,
} from './expert-bio.variants';
